import { DefaultService, OpenAPI } from "api-client";
import { API_ROOT } from "../constants";
OpenAPI.WITH_CREDENTIALS = true;
OpenAPI.BASE = API_ROOT;

export { DefaultService };
export * from "api-client";
